import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RoleService {
  private _role = new BehaviorSubject<string | null>(this.getStoredRole());
  public role$ = this._role.asObservable();

  // Retrieve stored role from localStorage
  private getStoredRole(): string | null {
    return localStorage.getItem('userRole');
  }

  setUserRole(role: string): void {
    this._role.next(role);
    localStorage.setItem('userRole', role);
  }

  // Optional: clear the role on logout
  clearUserRole(): void {
    this._role.next(null);
    localStorage.removeItem('userRole');
  }

  getUserRole(): string | null {
    return this._role.getValue();
  }
}
